import { gql } from "@apollo/client"
import { api } from "lib/graphql/api"
import { mutate } from "lib/graphql/mutate"

export const saveProjectBridgeResolutionDecisions = api(async function saveProjectBridgeResolutionDecisions({
    id,
    decisions,
}) {
    return mutate(
        gql`
            mutation SaveProjectBridgeResolutionDecisions($id: ID!, $decisions: JSON!) {
                saveProjectBridgeResolutionDecisions(id: $id, decisions: $decisions)
            }
        `,
        { id, decisions },
        { returns: "saveProjectBridgeResolutionDecisions" }
    )
})
